import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_ENDPOINTS from '../../utils/apiEndpoints';

const AdminLogin = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            const response = await axios.post(API_ENDPOINTS.ADMIN_LOGIN, {
                email: username,
                password: password
            });
    
            // Storing token if login is successful
            localStorage.setItem("adminToken", response.data.token);
            localStorage.setItem("adminRole", response.data.user.role);
            navigate("/admin/dashboard"); // Redirect to dashboard
        } catch (err) {
            if (err.response) {
                const { success, message, data } = err.response.data;
                
                if (!success && data) {
                    if (data.email) {
                        setError(data.email[0]); // Display email validation error
                    } else if (data.password) {
                        setError(data.password[0]); // Display password validation error
                    } else {
                        setError(message || "Login failed. Please try again.");
                    }
                } else {
                    setError("Invalid credentials. Try again.");
                }
            } else {
                setError("An error occurred. Please try again.");
            }
        }
    };
    

    return (
        <div className="w-screen min-h-screen flex items-center justify-center bg-gray-50 px-4 sm:px-6 lg:px-8">
            <div className="relative py-3 sm:max-w-xs sm:mx-auto">
                <div className="min-h-96 px-8 py-6 mt-4 text-left bg-white rounded-xl shadow-lg">
                    <div className="flex flex-col justify-center items-center h-full select-none">
                        <div className="flex flex-col items-center justify-center gap-2 mb-8">
                            <a target="_blank">
                                <svg className="w-8" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <g clipPath="url(#clip0_14_1966)">
                                            <path d="M40.955 8H17C13.6863 8 11 10.6863 11 14V49.94C11 53.2537 13.6863 55.94 17 55.94H40.955C44.2687 55.94 46.955 53.2537 46.955 49.94V14C46.955 10.6863 44.2687 8 40.955 8Z" stroke="#000000" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></path>
                                            <path d="M34.971 26.011L28.978 31.97L34.971 37.996" stroke="#426AB2" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></path>
                                            <path d="M28.978 31.97H52.947" stroke="#426AB2" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_14_1966">
                                                <rect width="45.947" height="51.94" fill="white" transform="translate(9 6)"></rect>
                                            </clipPath>
                                        </defs>
                                    </g>
                                </svg>
                            </a>
                            <p className="m-0 text-[16px] font-semibold">Admin Login</p>
                        </div>

                        {error && <p className="text-red-500 text-xs">{error}</p>}

                        <div className="w-full flex flex-col gap-2">
                            <label className="font-semibold text-xs text-gray-400">User Name</label>
                            <input 
                                className="border rounded-lg px-3 py-2 mb-5 text-sm w-full outline-none" 
                                type="text" 
                                placeholder="Enter user name" 
                                value={username} 
                                onChange={(e) => setUsername(e.target.value)} 
                            />
                            <label className="font-semibold text-xs text-gray-400">Password</label>
                            <input 
                                className="border rounded-lg px-3 py-2 mb-5 text-sm w-full outline-none" 
                                type="password" 
                                placeholder="Enter password" 
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)} 
                            />
                            <button 
                                onClick={handleLogin} 
                                className="py-1 px-8 bg-blue-500 hover:bg-blue-800 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg cursor-pointer select-none">
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;